//import packages from node modules
import React, { useEffect, useRef, useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { change } from 'redux-form'

//import utilities functions
import {
  ADD_DOMAIN_PAGE,
  EDIT_DOMAIN_PAGE,
  checkStepHeight
} from '../../../../utilities/function/common'

import {
  getOrderingFlowType
} from '../../../../utilities/function/configuration'

import {
  getDataFromURL,
  getPageByURL
} from '../../../../utilities/function/urlparams'

import {
  getPriceByBillingCycleID
} from '../../../../utilities/function/billingCycle'

import {
  loadConfiguration
} from '../../../../app/action'


import {CUSTOM_HOSTING_FLOW} from "../../../../utilities/function/productFlow"

//import shared components
import Heading from '../../typography/heading'
import Description from '../../typography/description'
import Goback from '../../goback'

//import internals
import {SelectDomainConfigContext} from "./reducer"
import {SELECT_DOMAIN_CONFIG_FORM} from "./SelectDomainConfigForm"
import SelectDomainConfigForm from "./SelectDomainConfigForm"
import SubmitDomainConfigForm from "./SubmitDomainConfigForm"

import SelectDomainConfigReducer,{
  SelectDomainConfigProvider,
  SelectDomainConfigInitialState
} from "./reducer"

//defined shared variables
export const ID_PROTECTION = 'ID Protection'
export const AUTO_RENEW = 'Auto Renew'
export const EPP_CODE = 'EPP'
export const ELIGIBILITY_TYPE = 'Eligibility Type'
export const ELIGIBILITY_NUMBER = 'Eligibility Number'
export const DOMAIN = 'Domain'
export const TLD = 'TLD'
export const HIDDEN_VALIDATION = 'Hidden Validation'
export const TRANSFER_RENEW = 'Transfer Renew Period'

export const getUpsell = (dataInput, requestUpsellData) => {
  let list = {}
  const {upsells, domain, tld} = dataInput
  if (upsells && Object.keys(upsells).length > 0) {
    Object.keys(upsells).forEach(key => {
      if (upsells[key]) {
        const productID = parseInt(key.replace('option-', ''))
        const domainname = domain + tld
        const selectedUpsell = requestUpsellData.find(item => item.id === productID)
        const getBillingCycleID = () => {
          if (selectedUpsell && selectedUpsell.attributes) {
            const {price} = selectedUpsell.attributes
            if (price && price.length > 0) {
              return price[0].billing_cycle_id
            }
          }
          return null
        }
        const getProductType = () => {
          if (selectedUpsell && selectedUpsell.attributes) {
            const {service_type} = selectedUpsell.attributes
            if (service_type) {
              return service_type
            }
          }
          return null
        }

        const getAdddons = () => {
          let addedAddon = null
          if (selectedUpsell && selectedUpsell.attributes) {

            const {addons} = selectedUpsell.attributes
            if (addons && addons.length) {
              addedAddon = []
              addons.forEach(item => {
                if (item && item.price && getBillingCycleID()) {
                  const selectedPrice = getPriceByBillingCycleID(item.price, getBillingCycleID())
                  if (selectedPrice && selectedPrice.price === '0.00') {
                    addedAddon.push({
                      id: item.id,
                      billing_cycle_id: getBillingCycleID()
                    })
                  }
                }
              })
            }
          }
          return addedAddon
        }

        const upsellConfiguration = {
          name: domainname,
          selectedProduct: selectedUpsell,
          billing_cycle_id: getBillingCycleID(),
          upsell: true,
          id: productID,
          product_type: getProductType()
        }
        if (getAdddons()) {
          upsellConfiguration['addons'] = getAdddons()
        }

        const orderingFlow = getOrderingFlowType(productID)
        if(orderingFlow===CUSTOM_HOSTING_FLOW) {
          let {upsell} = window.app_config
          try {
            const upsellJSON = JSON.parse(`[${upsell}]`)
            if (upsellJSON && Array.isArray(upsellJSON)) {
              const selectedUpsell = upsellJSON.find(upsell => upsell.id === productID)
              if (selectedUpsell && selectedUpsell.config) {
                upsellConfiguration['config'] = selectedUpsell.config
              }
            }
          } catch (e) {
            console.log(e)
          }
        }

        list[productID + '-' + domainname] = upsellConfiguration
      }
    })
    return list
  }
  return null
}

let SelectDomainConfig = (props) => {
  //define variables
  const {domainList, location, history} = props
  const appDispatch = useDispatch()
  const {
    configurations,
    configForm
  } = useSelector(state =>
    ({
      configurations: state.app.configurations,
      configForm: state.form[SELECT_DOMAIN_CONFIG_FORM]
    })
  )
  const pageType = getPageByURL(location.search)
  const context = useContext(SelectDomainConfigContext)

  //convert object to string so it can be compared accurately
  const stringConfigurations = JSON.stringify(configurations)
  const contextString = JSON.stringify(context)

  //previous values
  const prevFormValues = useRef(null)
  const prevDomainListLength = useRef(null)
  const prevStringContext = useRef(null)
  const prevStringConfigurations = useRef(null)
  const prevInit = useRef(false)

  //main DOM
  const elementRef = useRef(null)

  //define callback functions
  const updatePriceCallback = useCallback(() => {
    if (configForm && configForm.values) {
      const {domain_config} = configForm.values
      if (domain_config && domain_config.length) {
        const newConfigurations = configurations
        domain_config.forEach(item => {
          const {domain, tld} = item
          if (domain && tld && newConfigurations[domain + tld]) {
            newConfigurations[domain + tld].billing_cycle_id = item.billing_cycle_id
          }
          if(pageType===EDIT_DOMAIN_PAGE){
            const {uuid} = getDataFromURL(location.search)
            if (uuid) {
              newConfigurations[uuid].billing_cycle_id = item.billing_cycle_id
            }
          }
        })
        loadConfiguration(newConfigurations, appDispatch)
      }
    }
  }, [configForm, appDispatch, configurations, location,pageType])
  const updateUpsells = useCallback(() => {
    if (configForm && configForm.values) {
      const {domain_config} = configForm.values
      const {state} = context
      const {requestUpsellData} = state
      let newConfigurations = configurations
      if (domain_config && domain_config.length && requestUpsellData && requestUpsellData.length > 0) {
        newConfigurations = {}
        domain_config.forEach((dataInput) => {
          const upsell = getUpsell(dataInput, requestUpsellData)
          if (configurations && Object.keys(configurations).length > 0) {
            Object.keys(configurations).forEach(key => {
              if (configurations[key] && !configurations[key].upsell) {
                newConfigurations[key] = configurations[key]
              }
            })
          }
          if (upsell && Object.keys(upsell) && Object.keys(upsell).length > 0) {
            Object.keys(upsell).forEach((key) => {
              newConfigurations[key] = upsell[key]
            })
          }
        })
      }
      loadConfiguration(newConfigurations, appDispatch)
    }
  }, [configForm, appDispatch, configurations, context])
  const noDomainFoundCallback = useCallback(()=>{
    const {a, domain, query,config} = getDataFromURL(location.search)
    if(domainList && domainList.length===0 && pageType===ADD_DOMAIN_PAGE && config==="true"){
      history.push(`${history.location.pathname}?a=${a}&domain=${domain}&query=${query}`)
    }
  },[domainList,history,pageType,location])
  const scrollOnValidationCallback = useCallback(()=>{
    if(configForm){
      const {anyTouched,submitFailed,syncErrors} = configForm
      if(anyTouched && submitFailed === true && syncErrors){
        const {domain_config} = syncErrors
        if(domain_config && Array.isArray(domain_config) && domain_config.length > 0){
          return domain_config.find((item,index)=>{
            if(item && Object.keys(item) && Object.keys(item).length >0){
              return Object.keys(item).find(key=>{
                const domainConfigElements = document.getElementsByClassName('of-domain-config')
                if(domainConfigElements && domainConfigElements.length > 0){
                  for (var el_index = 0; el_index < domainConfigElements.length; el_index++) {
                    if(el_index===index){
                      const parentList = document.getElementsByClassName('of-step of-domain-page-slider__step')
                      if(parentList && parentList.length){
                        let parent = parentList[0]
                        const el = domainConfigElements[el_index]
                        if(parent && domainConfigElements[el_index] && el.offsetTop){
                          if(parent.scrollTo){
                            parent.scrollTo({
                              top: el.offsetTop - 30,
                              left: 100,
                              behavior: 'smooth'
                            })
                          }else{
                            parent.scrollTop =  el.offsetTop - 30
                          }
                        }
                      }
                    }
                  }
                }
                return item[key]==="Required"
              })
            }
            return null
          })
        }
      }
    }

  },[configForm])
  const domainListUpdated = useCallback(()=>{
    if(domainList && prevDomainListLength.current !== domainList.length && configForm && configForm.values){
      const {domain_config} = configForm.values
      if(domainList && domainList.length && domain_config && domain_config.length && prevDomainListLength.current>domainList.length){
        let new_domain_config = []
        domainList.forEach(config=>{
          if(config && config.domainSearchResult){
            const {domain,tld} = config.domainSearchResult
            const config_key = domain+tld
            domain_config.forEach(input=>{
              const {domain,tld} = input
              const input_key = domain + tld
              if(input_key === config_key){
                new_domain_config.push(input)
              }
            })
          }
        })
        if(new_domain_config && new_domain_config.length){
          appDispatch(change(SELECT_DOMAIN_CONFIG_FORM,'domain_config',Object.assign([],new_domain_config)))
        }
      }
      prevDomainListLength.current = domainList.length
    }

  },[domainList,configForm,appDispatch])
  const formValuesChangesCallback = useCallback(()=>{
    if (configForm && configForm.values) {
      const stringValues = JSON.stringify(configForm.values)
      if (stringValues !== prevFormValues.current) {
        updatePriceCallback()
        updateUpsells()
        scrollOnValidationCallback()
        checkStepHeight(elementRef)
        prevFormValues.current = stringValues
      }
    }
  },[configForm,prevFormValues,updatePriceCallback,updateUpsells,scrollOnValidationCallback,elementRef])
  const onWindowResizeCallback = useCallback(() => {
    checkStepHeight(elementRef)
  },[elementRef])
  const onChangeConfigurationCallback = useCallback(() => {
    if (prevStringConfigurations.current !== stringConfigurations) {
      checkStepHeight(elementRef)
      prevStringConfigurations.current = stringConfigurations
    }
  },[prevStringConfigurations,stringConfigurations,elementRef])
  const onContextChangeCallback = useCallback(()=>{
    if (prevStringContext.current !== contextString) {
      checkStepHeight(elementRef)
      prevStringContext.current = contextString
    }
  },[prevStringContext,contextString,elementRef])
  const initCallback = useCallback(()=>{
    if(!prevInit.current){
      window.addEventListener('resize', onWindowResizeCallback)
      prevInit.current = true
    }
    return(()=>{
      window.removeEventListener('resize', onWindowResizeCallback)
    })
  },[prevInit,onWindowResizeCallback])

  const {domainConfigFormSubmit} = SubmitDomainConfigForm()

  //define render functions
  const renderGoBack = () => {
    const {a, domain, query, promo} = getDataFromURL(location.search)
    if (pageType === ADD_DOMAIN_PAGE) {
      const promoParams = promo ? `&promo=${promo}`:''
      return (
          <Goback
              url={`${window.location.pathname}?a=${a}&domain=${domain}&query=${query}${promoParams}`}
              className={'of-select-domain-config__back'}>
            <i className={'icon icon-of-search'}/> Back to search
          </Goback>
      )
    }
    return (<></>)
  }

  useEffect(() => {
    initCallback()
    formValuesChangesCallback()
    noDomainFoundCallback()
    scrollOnValidationCallback()
    domainListUpdated()
    onChangeConfigurationCallback()
    onContextChangeCallback()
  }, [
    initCallback,
    formValuesChangesCallback,
    noDomainFoundCallback,
    scrollOnValidationCallback,
    domainListUpdated,
    onChangeConfigurationCallback,
    onContextChangeCallback
  ])

  return (
    <div className={'of-step of-domain-page-slider__step of-select-domain-config'} ref={elementRef}>
      {renderGoBack()}
      <div className={'of-step__wrapper of-select-domain-config__wrapper'}>
        <Heading className={'of-select-domain-config__heading'}>Domain Configuration</Heading>
        <Description className={'of-select-domain-config__description'}>Please review and configure your domain name/s below.</Description>
        <SelectDomainConfigForm
          domainList={domainList}
          onSubmit={domainConfigFormSubmit}
        />
      </div>
    </div>
  )
}
SelectDomainConfig = withRouter(SelectDomainConfig)
SelectDomainConfig.propTypes = {
  domainList: PropTypes.any,
  location: PropTypes.any,
  history: PropTypes.any
}

let SelectDomainConfigWrapper = (props) => {
  const {domainList, setDomainPage} = props
  return <SelectDomainConfigProvider
      initialState={SelectDomainConfigInitialState}
      reducer={SelectDomainConfigReducer}
      setDomainPage={setDomainPage}>
    <SelectDomainConfig domainList={domainList}/>
  </SelectDomainConfigProvider>
}
SelectDomainConfigWrapper.propTypes = {
  domainList: PropTypes.any,
  setDomainPage: PropTypes.func
}

export default SelectDomainConfigWrapper
